module.exports = __webpack_public_path__ + "images/aeed77a8b9081818ddf762cf8f7e2829.png";